import { useContext, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { Box, ThemeProvider, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import RewampAppBar from "../rewamp/components/RewampAppBar";
import { RewampFooter } from "../rewamp/components/RewampFooter";
import { useDisplayMode } from "../rewamp/context/DisplayModeContext";
import { usePwaChrome } from "../rewamp/context/PwaChromeContext";
import { bottomBarOffset } from "../rewamp/layouts/navMetrics";
import { PWA_LAYOUT } from "../rewamp/layouts/pwaConfig";
import { AppLayoutContext } from "../contexts/AppLayoutContext";
import generateRewampTheme from "../rewamp/theme";

// Only the chrome is rewamp-themed; the Outlet keeps the App.js legacy theme.
export default function DefaultLayout() {
  const {
    handleLogout,
    decreaseFontSize,
    increaseFontSize,
    resetTextSize,
    ourTheme,
    initData,
    fontSize,
  } = useContext(AppLayoutContext);

  const isMdUp = useMediaQuery(useTheme().breakpoints.up("md"));
  const { standalone } = useDisplayMode();
  const { header: pwaHeader } = usePwaChrome();

  const rewampTheme = useMemo(
    () => generateRewampTheme(fontSize, ourTheme),
    [fontSize, ourTheme]
  );

  const mainClassName = `app-body ${isMdUp ? "app-body-md" : ""}`;

  if (standalone) {
    return (
      <Box
        component="main"
        className={mainClassName}
        id="main-portal"
        sx={{ pb: bottomBarOffset(0), ...(!pwaHeader && { pt: PWA_LAYOUT.topInset }) }}
      >
        <Outlet />
      </Box>
    );
  }

  return (
    <>
      <ThemeProvider theme={rewampTheme}>
        <RewampAppBar
          handleLogout={handleLogout}
          decreaseFontSize={decreaseFontSize}
          increaseFontSize={increaseFontSize}
          ourTheme={ourTheme}
          resetTextSize={resetTextSize}
        />
      </ThemeProvider>
      <main className={mainClassName} id="main-portal">
        <Outlet />
      </main>
      <ThemeProvider theme={rewampTheme}>
        <RewampFooter initData={initData} />
      </ThemeProvider>
    </>
  );
}
